const getVoucherFromVoucherCode = (vouchersData, voucherCode) =>
  vouchersData?.find((voucher) => voucher.voucherCode === voucherCode);

export default getVoucherFromVoucherCode;
